import { Button, Divider } from "antd";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import checkIcon from "../../../../../assets/images/Event-2025/check.svg";
import superAttemptIcon from "../../../../../assets/images/Event-2025/super-attempt-coin.svg";
import attemptIcon from "../../../../../assets/images/Event-2025/attempt-coin.svg";
import plusIcon from "../../../../../assets/images/Event-2025/plus.svg";
import minusIcon from "../../../../../assets/images/Event-2025/minus.svg";
import placeBidIcon from "../../../../../assets/images/Event-2025/place-bid.png";
import buyBidIcon from "../../../../../assets/images/Event-2025/buy-bid.png";
import "./index.scss";
import CardChange from "./CardChange";
import {
  ID_TAB_EVENT_THINGYAN_2025,
  MISSION_CARD_TYPE as TYPE,
  POPUP_VARIANT_EVENT_THINGYAN_2025 as VARIANT,
} from "../../../../../helper/const";
import PATH from "../../../../../config/PATH";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { curStateAccount } from "../../../../../Redux/selector";
import { useSelector } from "react-redux";
/**
 * Displays a mission card with an icon, title, status, and prize information.
 *
 *
 * @param {string} icon - The icon for the mission.
 * @param {string} title - The title of the mission.
 * @param {string} status - The status of the mission (default: "pending").
 * @param {boolean} isSuper - Indicates if it's a super attempt (default: true).
 * @param {number} attempt - The number of attempts (default: 1).
 * @param {string} type - The type of the mission card (default: "primary"). Available types: primary, secondary, change, earn, earn-change.
 */

function MissionCard({
  icon,
  title,
  status = "pending",
  isSuper = true,
  attempt = 1,
  attemptSuper = 0,
  type = TYPE.primary,
  earnSmall = false,
  handleExecute = () => {
    console.log("no props excute");
  },
}) {
  return (
    <CardContainer
      isEarnAll={type === TYPE.earnChangeAll}
      className="mission-card"
    >
      {renderType(
        type,
        icon,
        title,
        status,
        isSuper,
        attempt,
        earnSmall,
        attemptSuper,
        handleExecute
      )}
    </CardContainer>
  );
}

const renderType = (
  type,
  icon,
  title,
  status,
  isSuper,
  attempt,
  earnSmall,
  attemptSuper,
  handleExecute
) => {
  switch (type) {
    case TYPE.primary:
      return (
        <CardPrimary
          icon={icon}
          title={title}
          status={status}
          isSuper={isSuper}
          attempt={attempt}
          attemptSuper={attemptSuper}
          handleExecute={handleExecute}
        />
      );
    case TYPE.secondary:
      return (
        <CardSecondary
          icon={icon}
          title={title}
          status={status}
          isSuper={isSuper}
          attempt={attempt}
          attemptSuper={attemptSuper}
          handleExecute={handleExecute}
        />
      );
    case TYPE.change:
      return <CardChange />;
    case TYPE.earnChangeAll:
      return (
        <>
          <div className="earn-container">
            <CardEarnMore
              icon={icon}
              status={status}
              type={TYPE.earn}
              isSmall={earnSmall}
            />
          </div>
          <div style={{ marginTop: "12px" }}>
            <CardEarnMore
              icon={icon}
              status={status}
              type={TYPE.earnChange}
              isSmall={earnSmall}
              handleExecute={handleExecute}
            />
          </div>
        </>
      );
    case TYPE.earn:
      return (
        <CardEarnMore
          icon={icon}
          status={status}
          type={TYPE.earn}
          isSmall={earnSmall}
        />
      );
    case TYPE.earnChange:
      return (
        <CardEarnMore
          icon={icon}
          status={status}
          type={TYPE.earnChange}
          isSmall={earnSmall}
          handleExecute={handleExecute}
        />
      );
    default:
      return (
        <CardPrimary
          icon={icon}
          title={title}
          status={status}
          isSuper={isSuper}
          attempt={attempt}
        />
      );
  }
};

const CardPrimary = ({
  icon,
  title,
  status,
  isSuper,
  attempt,
  attemptSuper,
  handleExecute,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <CardTitle>
        <div className="card-title-wrapper">
          <img src={icon} alt="mission card icon" className="card-icon" />
          <span className="card-title">{title}</span>
        </div>

        <StatusButton
          status={status}
          type="primary" // type button của antd
          icon={
            status === "pending" ? "" : <img src={checkIcon} alt="check icon" />
          }
          className="card-button"
          onClick={status === "pending" ? handleExecute : () => {}}
        >
          {status === "pending"
            ? t("event_thingyan.home_page.execute")
            : t("event_thingyan.home_page.completed")}
        </StatusButton>
      </CardTitle>
      <PrizeContainer>
        <Prize>
          <img src={attemptIcon} alt="attempt icon" />
          <span className="prize-text">
            {`+${attempt} ${
              attempt === 1
                ? t("event_thingyan.home_page.coins").replace("coins", "coin")
                : t("event_thingyan.home_page.coins")
            }`}{" "}
          </span>
        </Prize>
        {isSuper && (
          <>
            <Divider type="vertical" />
            <Prize>
              <img src={superAttemptIcon} alt="super attempt icon" />
              <span className="prize-text text-gold">
                {`+${attemptSuper} ${
                  attemptSuper === 1
                    ? t("event_thingyan.home_page.super")
                    : t("event_thingyan.home_page.super").replace(
                        "coin",
                        "coins"
                      )
                }`}
              </span>
            </Prize>
          </>
        )}
      </PrizeContainer>
    </>
  );
};

const CardSecondary = ({
  icon,
  title,
  status,
  attempt,
  attemptSuper,
  handleExecute,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <CardTitle>
        <div className="card-title-wrapper">
          <img src={icon} alt="mission card icon" />
          <div className="card-title-inner-wrapper">
            <div className="card-title">{title}</div>
            <div className="item-flex-center">
              <Prize>
                <img
                  src={attemptIcon}
                  alt="attempt icon"
                  width={30}
                  height={30}
                />
                <span className="prize-text">
                  {`+${attempt} ${
                    attempt === 1
                      ? t("event_thingyan.home_page.coins").replace(
                          "coins",
                          "coin"
                        )
                      : t("event_thingyan.home_page.coins")
                  }`}{" "}
                </span>
              </Prize>
              {attemptSuper ? (
                <Prize>
                  <img
                    src={superAttemptIcon}
                    alt="attempt icon"
                    width={30}
                    height={30}
                  />
                  <span className="prize-text text-gold">
                    {`+${attemptSuper} ${
                      attemptSuper === 1
                        ? t("event_thingyan.home_page.super")
                        : t("event_thingyan.home_page.super").replace(
                            "coin",
                            "coins"
                          )
                    }`}
                  </span>
                </Prize>
              ) : null}
            </div>
          </div>
        </div>
      </CardTitle>
      <StatusButton
        onClick={status === "pending" ? handleExecute : () => {}}
        status={status}
        type="primary" // type button của antd
        icon={
          status === "pending" ? "" : <img src={checkIcon} alt="check icon" />
        }
        className="card-button"
      >
        {status === "pending"
          ? t("event_thingyan.home_page.execute")
          : t("event_thingyan.home_page.completed")}
      </StatusButton>
    </>
  );
};

const CardEarnMore = ({ type, status, isSmall, handleExecute }) => {
  const [bid, setBid] = React.useState(1);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selectorAccount = useSelector(curStateAccount);
  const [bidTotal, setBidTotal] = useState(0);
  const [isCheckContent, setIsCheckContent] = useState(false);
  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const bidTotal = selectorAccount.remainTurn?.reduce((acc, pack) => {
        return acc + pack?.turn;
      }, 0);
      setBidTotal(bidTotal);
    }
  }, [selectorAccount.remainTurn]);

  const handleAddBid = () => {
    if (!bidTotal) {
      return setIsCheckContent(true);
    }
    if (+bid === +bidTotal) {
      return setIsCheckContent(true);
    }
    setBid(bid + 1);
  };

  const handleMinusBid = () => {
    if (bid > 1) {
      setBid(bid - 1);
      setIsCheckContent(false);
    }
  };

  const handleActionBid = () => {
    if (!bidTotal) {
      return;
    }
    handleExecute(bid);
  };

  const handleActionEarn = () => {
    const isCheckPageCollectPiece = window.location.href.includes(
      ID_TAB_EVENT_THINGYAN_2025.collectPiece
    );
    if (isCheckPageCollectPiece) {
      const element = document.getElementById("id-missions-list__event-2025");
      
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }

      return null;
    }

    navigate(`${PATH.EVENT_THINGYAN}/${ID_TAB_EVENT_THINGYAN_2025.collectPiece}`)
  };

  return (
    <>
      <CardTitle className="card-more-container">
        <div className={`card-title-wrapper ${isSmall ? "small" : ""}`}>
          <img
            src={
              type === TYPE.earn
                ? buyBidIcon
                : TYPE.earnChange
                ? placeBidIcon
                : ""
            }
            alt="mission card icon"
            className="card-icon"
          />
          <div className="card-title-inner-wrapper">
            <div>
              <p className="card-title">
                {type === TYPE.earn
                  ? t("event_thingyan.home_page.mission_to_earn")
                  : TYPE.earnChange
                  ? t("event_thingyan.home_page.change_by_bid")
                  : ""}
              </p>
              <p className="card-desc">
                {type === TYPE.earn
                  ? t("event_thingyan.prize_collection.complete_to_earn_more")
                  : TYPE.earnChange
                  ? t("event_thingyan.home_page.1_bid_1_coin")
                  : ""}
              </p>
            </div>
            {type === TYPE.earnChange && (
              <div className="change-bid-action-wrapper">
                <div className="change-bid-action-inner-wrapper short">
                  <Button
                    icon={<img src={minusIcon} alt="minus icon" />}
                    className="change-bid-action-btn"
                    onClick={handleMinusBid}
                  />
                  <span className="bid-number">{bid}</span>
                  <Button
                    icon={<img src={plusIcon} alt="plus icon" />}
                    className="change-bid-action-btn"
                    onClick={() => handleAddBid()}
                  />
                </div>
              </div>
            )}
            {isCheckContent ? (
              <div className="content-error-bid">
                ဝမ်းနည်းပါတယ်။ Coins တွေ လဲလှယ်ဖို့ ကစားခွင့် မလုံလောက်ပါ။
              </div>
            ) : null}
          </div>
        </div>
        <StatusButton
          status={status}
          type="primary"
          icon={
            status === "pending" ? "" : <img src={checkIcon} alt="check icon" />
          }
          className={isSmall ? "card-button small" : "card-button"}
          onClick={
            type === TYPE.earn ? handleActionEarn : () => handleActionBid(bid)
          }
        >
          {status === "pending"
            ? t("event_thingyan.home_page.execute")
            : t("event_thingyan.home_page.completed")}
        </StatusButton>
      </CardTitle>
    </>
  );
};

const CardContainer = styled.div`
  /* background-color: var(--bg-white); */
  background-color: ${(props) => (props.isEarnAll ? "" : "white")};
  border-radius: ${(props) => (props.isEarnAll ? "0" : "20px")};
  padding: ${(props) => (props.isEarnAll ? "0" : "13px")};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  /* max-width: 512px; */
  width: 100%;
  z-index: 9;

  .card-button {
    justify-content: center;
  }

  .card-more-container {
    padding: 20px;
    background-color: white;
    border-radius: 20px;
  }

  .earn-container {
    .card-title-inner-wrapper {
      .card-title {
        padding-bottom: 8px;
      }
    }
  }

  @media (max-width: 320px) {
    max-width: 100%;
    padding: 8px;
  }

  /* & + & {
    margin-top: 8px;

    @media (min-width: 425px) {
      margin-top: 12px;
    }
  } */
`;

const CardTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  .item-flex-center {
    display: flex;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
  }
  @media (max-width: 425px) {
    gap: 8px;
  }
`;

const StatusButton = styled(Button)`
  background-color: ${(props) =>
    props.status === "pending" ? "var(--bg-orange)" : "var(--bg-green)"};
  padding: 12px;
  min-height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${(props) =>
      props.status === "pending"
        ? "var(--bg-orange)!important"
        : "var(--bg-green)!important"};
  }

  &:active {
    background-color: ${(props) =>
      props.status === "pending"
        ? "var(--bg-orange)!important"
        : "var(--bg-green)!important"};
  }

  .ant-btn-icon {
    height: 28px;
    width: 28px;

    @media (max-width: 425px) {
      height: 24px;
      width: 24px;
    }
  }
`;

const ChangeButton = styled(Button)`
  background-color: var(--bg-orange);
  width: 100%;
  padding: 12px;
  min-height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: var(--bg-orange) !important;
  }

  &:active {
    background-color: var(--bg-orange) !important;
  }
`;

const PrizeContainer = styled.div`
  background-color: var(--bg-prize-container);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 62px;
  gap: 10px;

  .ant-divider {
    border-color: var(--bg-divider);
    height: 1.9em;
  }

  @media (max-width: 425px) {
    gap: 12px;
    padding: 12px;
  }

  @media (max-width: 375px) {
    gap: 6px;
    padding: 8px;
  }
`;

const Prize = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .prize-text {
    color: var(--text-blue);
    font-weight: bold;
    font-size: 14px;

    &.text-gold {
      color: var(--text-orange);
    }
  }

  & > img {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 475px) {
    gap: 4px;
    & > img {
      width: 24px;
      height: 24px;
    }
    .prize-text {
      font-size: 12px;
    }
  }

  @media (max-width: 375px) {
    .prize-text {
      font-size: 10px;
    }
  }
`;

export default MissionCard;
